<template lang="pug">
  v-dialog(
    :value="true"
    v-bind="dialogProps"
    @click:outside="$modals.close()"
  )
    v-card(v-bind="DIALOG_TYPES_DATA[type].cardAttrs").pa-4
      v-card-title(v-if="title" v-bind="DIALOG_TYPES_DATA[type].cardTitleAttrs")
        v-icon.mr-2(
          v-if="DIALOG_TYPES_DATA[type].icon"
          v-bind="DIALOG_TYPES_DATA[type].cardTitleAttrs"
        ) {{ icon || DIALOG_TYPES_DATA[type].icon }}
        h4 {{ title }}
      v-card-text.mt-4.subtitle-1(v-bind="DIALOG_TYPES_DATA[type].cardTextAttrs")
        .mb-5(
          v-html="message"
        )
        component(
          v-if="component"
          v-model="componentData"
          :is="component"
          v-bind="componentProps"
        )
      v-card-actions
        v-btn.px-4(
          color="secondary"
          rounded
          depressed
          :loading="loading"
          @click="accept"
        ) {{ acceptBtnText }}
        v-spacer
        v-btn.px-4(
          text
          rounded
          @click="decline"
        ) {{ cancelBtnText }}
</template>

<script>
import { DIALOG_TYPES_DATA } from '../constants';

export default {
  props: {
    title: { type: String, default: 'Подтвердите действие' },
    message: { type: String, default: 'Подтвердить действие?' },
    icon: { type: String, default: null },
    component: { type: [Object, String], default: null },
    componentProps: { type: Object, default: () => ({}) },
    componentInitialData: { type: [Object, String, Array, Number], default: null },

    dialogProps: {
      type: Object,
      default: () => ({
        width: 560,
      }),
    },

    method: { type: Function, default: null },

    acceptBtnText: { type: String, default: 'Подтвердить' },
    cancelBtnText: { type: String, default: 'Отмена' },

    type: { type: String, default: 'info' },
  },
  data() {
    return {
      componentData: null,
      dialog: false,
      loading: false,
      DIALOG_TYPES_DATA,
    };
  },
  created() {
    this.componentData = this.componentInitialData;
  },
  methods: {
    decline() {
      this.$modals.close();
    },
    async accept() {
      this.loading = true;
      if (this.method) {
        try {
          await this.method(this.componentData);
          this.$modals.close();
        } catch (e) {
          console.log(e);
        }
      }
      this.loading = false;
    },
  },
};
</script>
